import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import GamePage from './pages/GamePage';
import RubricPage from './pages/RubricPage';
import './App.css';

function App() {
  return (
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/game" element={<GamePage />} />
          <Route path="/rubric" element={<RubricPage />} />
        </Routes>
      </div>
  );
}

export default App;
